import * as React from 'react';

import { LabeledTextInputProps } from 'types/inputProps';
import LabeledTextInput from '../TextInput/LabeledTextInput';

const LabeledDateInput = (props: LabeledTextInputProps): React.JSX.Element => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <LabeledTextInput {...props} />
);

export default React.memo(
  LabeledDateInput,
  (prevProps: Readonly<LabeledTextInputProps>, nextProps: Readonly<LabeledTextInputProps>) => (
    prevProps.value === nextProps.value
    && prevProps.error === nextProps.error
  ),
);
